import {AuthHttpInterceptor, AuthService, FireAuthService} from '@indosuara/auth';
import {DEFAULT_ORDER_SHOP_CODE_FILTER, QINVENTORY_BASE_URL, REMIT_AUTO_ARC_BASE_URL, REMIT_BASE_URL, REMIT_NOTIFICATION_VAPID_PUBLIC_KEY} from '@indosuara/remit-api';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {browserLocalPersistence, connectAuthEmulator, getAuth, provideAuth} from '@angular/fire/auth';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';

import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {ISMEMBER_BASE_URL} from 'ismember-api';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatToolbarModule} from '@angular/material/toolbar';
import {NavigationMenuComponent} from './navigation-menu/navigation-menu.component';
import {NgModule} from '@angular/core';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {RouterModule} from '@angular/router';
import {ServiceWorkerModule} from '@angular/service-worker';
import {appRoutes} from './app.routes';
import {environment} from '../environments/environment';
import {setPersistence} from '@firebase/auth';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, {initialNavigation: 'enabledBlocking'}),
    MatSnackBarModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatSidenavModule,
    MatMenuModule,
    MatAutocompleteModule,
    NavigationMenuComponent,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.useServiceWorker,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => {
      const auth = getAuth();
      auth.tenantId = environment.staffTenantId ?? 'employee-bml6n';
      setPersistence(auth, browserLocalPersistence);
      if (environment.useEmulators) {
        connectAuthEmulator(auth, 'http://localhost:9099', {
          disableWarnings: true,
        });
      }
      return auth;
    }),
    {
      provide: AuthService,
      useClass: FireAuthService,
    },
    {
      provide: REMIT_NOTIFICATION_VAPID_PUBLIC_KEY,
      useValue: environment.vapidPublicKey,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    {
      provide: REMIT_BASE_URL,
      useValue: environment.indosuaraApiUrl + '/remitz/api/v0',
    },
    {
      provide: QINVENTORY_BASE_URL,
      useValue: environment.indosuaraApiUrl + '/qinventory/api/v0/staff',
    },
    {
      provide: REMIT_AUTO_ARC_BASE_URL,
      useValue: environment.indosuaraApiUrl + '/arc-automation',
    },
    {
      provide: ISMEMBER_BASE_URL,
      useValue: environment.indosuaraApiUrl,
    },
    {
      provide: DEFAULT_ORDER_SHOP_CODE_FILTER,
      useValue: 'P88',
    },
    provideHttpClient(withInterceptorsFromDi()),
  ]})
export class AppModule {}
